module.exports = __webpack_public_path__ + "static/media/about-us-text-image.e2af122d.jpg";